import React from 'react';
import '../Pages/css/preloader.css'
import { useState } from "react";

export default function Preloader() {

    const [showElement, setShowElement] = useState(true);

    setTimeout(function () {
        setShowElement(false);
    }, 4000);
     
    return (
        <>
            {showElement &&
                <div id="preload">
                    <video autoPlay muted>
                        <source src="../Video/preloader2.mp4" type="video/mp4" />
                    </video>
                </div>
            }
        </>
    )
}
